<script lang="ts">
    /**
     * Catalog slideshow
     */
    import { onMount } from "svelte";

    import type { PagesViewSlideshow } from "../model";
    export let listPagesCatalog: PagesViewSlideshow[];
    export let pageIndex: number = 1;
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

    onMount(() => {});

    /**
     * change choosed page
     * @param index
     */
    function choosePage(index: number): void {
        pageIndex = index;
        dispatch("go-to-page", pageIndex);
    }
</script>

<div class="slides">
    {#each listPagesCatalog as thumbs}
        <!-- Slide -->
        <div
            class="slide"
            class:active={pageIndex === thumbs.index + 1}
            on:click={() => choosePage(thumbs.index + 1)}
        >
            <!-- Pages -->
            <div class="pages">
                {#each thumbs.pages as thumb, i}
                    <!-- Page -->
                    <div class="page">
                        <!-- Img -->
                        <img
                            src="{thumb.source}?g=500x500"
                            alt="page {i + 1}"
                            title="page {i + 1}"
                        />
                        <!-- Index page -->
                        <div class="page-index">
                            <!-- index page + index of image-->
                            {thumbs.index + i + 1}
                        </div>
                    </div>
                {/each}
            </div>
        </div>
    {/each}
</div>

<style lang="scss">
    @import "../styles/variables";

    .slides {
        display: grid;
        column-gap: 50px;
        row-gap: 50px;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        margin: 1rem;

        @media (max-width: $mobile-breakpoint) {
            grid-template-columns: 1fr 1fr;
        }
        .slide {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            &:hover {
                background-color: $dark-mauve;
            }

            &.active {
                background-color: $dark-mauve;
            }
            .pages {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                margin: 10px;
                .page {
                    display: flex;
                    flex-direction: column;
                    flex-wrap: nowrap;
                    align-items: center;
                    justify-content: center;
                    max-width: 50%;
                    @media (max-width: $large-screen-breakpoint) {
                        max-width: 100%;
                    }

                    img {
                        max-width: 100%;
                        height: auto;
                    }
                    .page-index {
                        color: white;
                    }
                }
            }
        }
    }
</style>
